import { Box, Icon } from "native-base";
import React from "react";

type ComponentProps = {
  icon: any;
  boxSize?: string;
  iconSize?: string;
};

const RoundedIcon = ({ icon, boxSize = "20", iconSize = "3xl" }: ComponentProps) => {
  return (
    <Box
      size={boxSize}
      rounded="full"
      bgColor="white.50"
      shadow="4"
      justifyContent="center"
      alignItems="center">
      <Icon as={icon} size={iconSize} color="primary.600" />
    </Box>
  );
};

export default RoundedIcon;
